export const STATUS_CODES = {
  BAD_REQUEST: 400,
  NOT_AUTHORIZED: 401,
  NOT_FOUND: 404,
  SUCCESS: 200
};
